import { render, staticRenderFns } from "./MyProfileDisplay.vue?vue&type=template&id=0f17f6d1&scoped=true"
import script from "./MyProfileDisplay.vue?vue&type=script&lang=ts"
export * from "./MyProfileDisplay.vue?vue&type=script&lang=ts"
import style0 from "./MyProfileDisplay.vue?vue&type=style&index=0&id=0f17f6d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17f6d1",
  null
  
)

export default component.exports